var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyOrgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "163px",
    height: "131px",
    viewBox: "0 0 163 131",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "269DD342-650D-423B-8631-6C1F9C16C730@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "56.688835%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FBFB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.043137 0 0 0 0 0.576471 0 0 0 0 0.556863 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Template--list-",
    transform: "translate(-750.000000, -394.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(710.000000, 394.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(40.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    fill: "#C7C7C7",
    opacity: 0.376627604,
    cx: 86.3200014,
    cy: 117.24,
    rx: 61.3200014,
    ry: 9.24000021
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#E2E2E2",
    cx: 149.44,
    cy: 86.4400003,
    r: 13.4400003
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#E2E2E2",
    cx: 7.98000018,
    cy: 76.9800002,
    r: 7.98000018
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    fill: "#E2E2E2",
    cx: 109.98,
    cy: 7.98000018,
    r: 7.98000018
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.360000, 16.360000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9899965,8.40000019 C51.9821664,8.40000019 54.6927875,10.1647559 55.9034903,12.9010453 L60.9729996,24.3600002 L103.453948,24.3600006 C106.892952,24.3600006 109.898632,26.6810696 110.768251,30.0083078 L126.136433,88.8083092 C127.192232,92.8478873 124.773401,96.9785065 120.733823,98.0343054 C120.109685,98.1974324 119.467234,98.2800022 118.82213,98.2800022 L23.570028,98.2800022 C20.1310236,98.2800022 17.1253437,95.9589332 16.2557247,92.631695 L0.887542505,33.8316936 C-0.168256335,29.7921155 2.25057473,25.6614963 6.2901529,24.6056974 C6.73642788,24.4890574 7.19206545,24.4136032 7.65134093,24.3800705 L7.65198657,15.9600004 C7.65198657,11.7847276 11.0367139,8.40000019 15.2119867,8.40000019 L48.9899965,8.40000019 Z",
    id: "Combined-Shape-Copy",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3106819,0 C68.4074742,3.87202058e-15 71.1911153,1.88864872 72.3355253,4.76622555 L77.455,17.64 L118.320002,17.6400004 C122.495275,17.6400004 125.880003,21.0247278 125.880003,25.2000006 L125.880003,90.7200021 C125.880003,94.8952749 122.495275,98.2800022 118.320002,98.2800022 L22.5600002,98.2800022 C18.3847274,98.2800022 15,94.8952749 15,90.7200021 L15,25.2000006 C15,21.0247278 18.3847274,17.6400004 22.5600002,17.6400004 L24.24,17.64 L24.2400002,7.56000017 C24.2400002,3.38472737 27.6247276,7.66985171e-16 31.8000004,0 L65.3106819,0 Z",
    id: "Combined-Shape",
    stroke: "#8F8F8F",
    strokeWidth: 3,
    fill: "url(#linearGradient-1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.1800018,90.5663988 C94.978992,90.5663988 99.6800018,87.7457926 99.6800018,84.2663986 C99.6800018,80.7870046 94.558992,84.2663986 88.760002,84.2663986 C82.961012,84.2663986 78.6800018,80.7870046 78.6800018,84.2663986 C78.6800018,87.7457926 83.381012,90.5663988 89.1800018,90.5663988 Z",
    id: "Oval",
    fill: "#8F8F8F",
    transform: "translate(89.180002, 86.643200) scale(1, -1) translate(-89.180002, -86.643200) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(59.000000, 57.000000)",
    fill: "#B3B3B3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.6200001,
    cy: 4.6200001,
    r: 4.6200001
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    cx: 54.1800012,
    cy: 4.6200001,
    r: 4.6200001
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(118.000000, 20.560000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.56000017,28.5600006 C11.735273,28.5600006 15.1200003,25.0376827 15.1200003,20.6926834 C15.1200003,16.3476841 11.735273,1.68000004 7.56000017,1.68000004 C3.38472737,1.68000004 -2.13162821e-13,16.3476841 -2.13162821e-13,20.6926834 C-2.13162821e-13,25.0376827 3.38472737,28.5600006 7.56000017,28.5600006 Z",
    id: "Oval-Copy-6",
    opacity: 0.200000003
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2400002,26.8800006 C15.415273,26.8800006 18.8000004,23.3576827 18.8000004,19.0126834 C18.8000004,14.667684 15.415273,0 11.2400002,0 C7.06472741,0 3.68000004,14.667684 3.68000004,19.0126834 C3.68000004,23.3576827 7.06472741,26.8800006 11.2400002,26.8800006 Z",
    id: "Oval",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9599972,23.2400003 C13.6109641,23.2400003 15.7599974,21.090967 15.7599974,18.4400001",
    id: "Oval-Copy-8",
    stroke: "#FFFFFF",
    strokeWidth: 2.4000001,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(2.000000, 72.640001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-2)",
    id: "Group-6-Copy",
    opacity: 0.200000003
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.000000, 3.360000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 17.8787357,
    cy: 17.2200004,
    rx: 17.6400004,
    ry: 17.2200004
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.510321, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6074842,20.5438074 C17.9361825,20.5396628 19.0376281,21.5723118 19.1190693,22.8985183 L20.9360163,52.4860887 C21.0871729,54.947557 19.2142952,57.065508 16.7528269,57.2166646 C16.6663383,57.2219758 16.5797135,57.2247683 16.4930624,57.2250386 C14.0574856,57.232636 12.0769015,55.2643699 12.0693041,52.8287931 C12.0689802,52.7249438 12.0723246,52.6211154 12.0793311,52.5175022 L14.0812877,22.9123398 C14.1712349,21.5821901 15.2743033,20.5479661 16.6074842,20.5438074 Z",
    id: "Rectangle",
    stroke: "#656565",
    strokeWidth: 3,
    transform: "translate(16.493062, 38.888114) rotate(45.000000) translate(-16.493062, -38.888114) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#7A7A7A",
    strokeWidth: 3,
    fill: "#FFFFFF",
    cx: 36.8787357,
    cy: 17.2200004,
    rx: 17.6400004,
    ry: 17.2200004
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    fill: "#8F8F8F",
    cx: 36.8787357,
    cy: 17.2200004,
    r: 13.2000005
  }))), /*#__PURE__*/React.createElement("text", {
    id: "?",
    fontFamily: "Helvetica",
    fontSize: 19.2000008,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 33.9200018,
    y: 25.3600023
  }, "?")))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOrgImage);
export default __webpack_public_path__ + "static/media/emptyOrgImage.6f9f00efb2ea12ad3bdc4cc58ed5a157.svg";
export { ForwardRef as ReactComponent };